import {SearchModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class OrderAssignmentRuleSearchModel extends SearchModel<any> {

    constructor(injector: Injector) {
        super(injector);
    }

    override getIdentifierField(): string {
        return "id";
    }
}
